import React, { Component } from 'react';

import Title from './diagnosticReport/title'
import DocumentInformation from './diagnosticReport/document-information'
import Signature from './diagnosticReport/signature'
import UsedCertificates from './diagnosticReport/used-certificates'
import TrustedLists from './diagnosticReport/trusted-lists';

import { Container, Card } from 'react-bootstrap';

const titleStyle = {
	backgroundColor: "#003366",
	color: "#fff",
	fontWeight: "bold",
	fontSize: "18px"
}

export default class DiagnosticReport extends Component {
	constructor(props) {
		super(props);
		//console.log(this.props.report);
	}

	render() {
		return (
			<div className="container">
				<section>
					<Title reportId={this.props.reportId} />
				</section>
				<br />
				<section>
					<DocumentInformation signatures={this.props.report.signatures} documentName={this.props.documentName}
						reportGenerationTime={this.props.reportGenerationTime} permLinkValidUntil={this.props.permLinkValidUntil}
						hash={this.props.hash} linkId={this.props.linkId} language={this.props.language} />
				</section>
				<br />
				{this.props.report.signatures.length > 0 ?
					<section>
						<Card.Header style={titleStyle}>
							Signatures
						</Card.Header>
						{this.props.report.signatures.map((signatures, i) => {
							return <div key={i}><Signature data={signatures} index={i} handleKeyUp={this.props.handleKeyUp}/></div>
						})}
						<br />
					</section>
					: null
				}

				{this.props.report.usedCertificates.length > 0 ?
					<section>
						<Card.Header style={titleStyle}>
							Used Certificates
						</Card.Header>
						{this.props.report.usedCertificates.map((usedCertificates, i) => {
							return <div key={i}><UsedCertificates data={usedCertificates} serialNumbers={this.props.serialNumbers} index={i} handleKeyUp={this.props.handleKeyUp}/></div>
						})}
						<br />
					</section>
					: null
				}

				{this.props.report.trustedLists.length > 0 ?
					<section>
						<Card.Header style={titleStyle}>
							Trusted Lists
						</Card.Header>
						{this.props.report.listOfTrustedLists != null ?
							<TrustedLists data={this.props.report.listOfTrustedLists} handleKeyUp={this.props.handleKeyUp}/>
							:
							null
						}
						{this.props.report.trustedLists.map((trustedLists, i) => {
							return <div key={i}>
								<TrustedLists data={trustedLists} handleKeyUp={this.props.handleKeyUp}/>
							</div>
						})}
						<br />
					</section>
					: null
				}
			</div>
		);
	}
}